var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsAftereffects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 44.85,
    viewBox: "0 0 46 44.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skills_aftereffects",
    transform: "translate(-1172 -774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M8.146,0H37.854A8.139,8.139,0,0,1,46,8.146V36.7a8.139,8.139,0,0,1-8.146,8.146H8.146A8.139,8.139,0,0,1,0,36.7V8.146A8.139,8.139,0,0,1,8.146,0Z",
    transform: "translate(1172 774)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M42.476,75.495h-7.13L33.89,80.018a.335.335,0,0,1-.364.268h-3.6c-.211,0-.268-.115-.211-.345l6.172-17.691c.058-.192.115-.364.192-.594a6.7,6.7,0,0,0,.115-1.246.19.19,0,0,1,.153-.211h4.964c.134,0,.23.057.249.153l7,19.55c.058.211,0,.307-.192.307H44.355A.289.289,0,0,1,44.048,80l-1.572-4.6Zm-6.018-3.814h4.868c-.115-.4-.268-.882-.441-1.38-.173-.517-.345-1.073-.518-1.648-.192-.594-.364-1.169-.556-1.763s-.364-1.15-.518-1.706c-.153-.537-.287-1.035-.422-1.5h-.038a23.532,23.532,0,0,1-.652,2.472c-.287.92-.575,1.878-.882,2.837-.249.978-.556,1.878-.843,2.683Z",
    transform: "translate(1148 725.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M143.108,93.245h-6.076a4.223,4.223,0,0,0,.594,1.706,3.039,3.039,0,0,0,1.4,1.15,5.961,5.961,0,0,0,2.453.479,11.529,11.529,0,0,0,1.993-.211,7.2,7.2,0,0,0,1.706-.441c.1-.077.153-.038.153.153v2.932a.962.962,0,0,1-.038.23.448.448,0,0,1-.134.134,8.2,8.2,0,0,1-1.917.575,12.948,12.948,0,0,1-2.722.23,9.083,9.083,0,0,1-3.68-.671,6.454,6.454,0,0,1-2.415-1.821,7.033,7.033,0,0,1-1.323-2.511,9.93,9.93,0,0,1,.077-5.846,7.822,7.822,0,0,1,1.438-2.626,6.946,6.946,0,0,1,2.319-1.821,7.238,7.238,0,0,1,3.2-.594,6.924,6.924,0,0,1,2.971.594,5.279,5.279,0,0,1,2.012,1.533,7.017,7.017,0,0,1,1.15,2.185,7.539,7.539,0,0,1,.364,2.338c0,.46-.019.863-.038,1.227-.038.364-.058.632-.077.805a.286.286,0,0,1-.268.249c-.115,0-.326.019-.633.038a9.072,9.072,0,0,1-1.112.058C144.066,93.322,143.606,93.245,143.108,93.245Zm-6.076-2.8h4.044c.5,0,.863,0,1.092-.019a.937.937,0,0,0,.441-.153v-.192a2.2,2.2,0,0,0-.115-.709A2.537,2.537,0,0,0,140,87.61a2.7,2.7,0,0,0-2.549,1.457A3.973,3.973,0,0,0,137.032,90.447Z",
    transform: "translate(1064.734 705.863)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsAftereffects);
export default __webpack_public_path__ + "static/media/skills_aftereffects.a38b4953eff0c8407cd36e595b88652d.svg";
export { ForwardRef as ReactComponent };